import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_InitialDiagnosticProgressNote = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_InitialDiagnosticProgressNote' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader' >Consumer met goal (s) this session:</span>
                            <input type="text" id="txtSession" name="txtSession" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader' >Person(s) Involved::</span>
                            <input type="text" id="txtPersonInvolved" name="txtPersonInvolved" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader' >Consumer overall affect: </span>
                            <input type="text" id="txtOverallAffect" name="txtOverallAffect" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h4 >Service Plan Objectives/Interventions</h4>
                <br />
                <table>
                    <tr>
                        <td>
                            <span>Relevant Changes in Medical condition and/or Medications (health and safety stressor) since last visit?</span><br />
                            <input type="radio" id="rbRelevantChanges_No" name="rbRelevantChanges" className='add-only' value="Yes" /> Yes
                            &nbsp;
                            <input type="radio" id="rbRelevantChanges_Yes" name="rbRelevantChanges" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader' >If yes, please explain:</span>
                    <textarea id="txtExplain" name="txtExplain" className='add-only' ></textarea>
                </p>

                <h4 >Goal/Objectives/Interventions</h4>
                <p className='w-750'>
                    <span className='eleHeader' >Goal: Psychiatric/Assessment:</span>
                    Client will complete all requested assessments/evaluations (i.e. behavioral health, psychiatric/psychological, nursing, etc.) within 3 months
                    <textarea id="txtGoal" name="txtGoal" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Obj:</span>  Client will participate in treatment planning aeb answering questions, providing accurate information, and verbalizing at least 1 treatment goal per 3 months
                    <textarea id="txtObj" name="txtObj" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Int:</span>  MD/DO will prescribe medication and monitor its effectiveness
                    <textarea id="txtInt" name="txtInt" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader' >Chief Complaint</span>
                    <span className='small'>(Presenting Problem)</span>
                    <textarea id="txtChiefComplaintPresentingProblem" name="txtChiefComplaintPresentingProblem" className='add-only' ></textarea>
                </p>

                <h3>Behavior:</h3>

                <p className='w-750'>
                    <span className='eleHeader' >History:</span>
                    <textarea id="txtHistory" name="txtHistory" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Past Psychiatric History:</span>
                    <textarea id="txtPsychiatricHistory" name="txtPsychiatricHistory" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Suicide Attempts:</span>
                    <textarea id="txtSuicideAttempts" name="txtSuicideAttempts" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Hospitalizations:</span>
                    <textarea id="txtHospitalizations" name="txtHospitalizations" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Medications:</span>
                    <textarea id="txtMedications" name="txtMedications" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Medication Consent Form Signed:</span>
                    <textarea id="txtMedicationsConsent" name="txtMedicationsConsent" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Prior Diagnosis:</span>
                    <textarea id="txtPriorDiagnosis" name="txtPriorDiagnosis" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Medical History:</span>
                    <textarea id="txtMedicalHistory" name="txtMedicalHistory" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Family History:</span>
                    <textarea id="txtFamilyHistory" name="txtFamilyHistory" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Social History:</span>
                    <textarea id="txtSocialHistory" name="txtSocialHistory" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Lives With:</span>
                    <textarea id="txtLivesWith" name="txtLivesWith" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Education:</span>
                    <textarea id="txtEducation" name="txtEducation" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Occupation:</span>
                    <textarea id="txtOccupation" name="txtOccupation" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Legal History:</span>
                    <textarea id="txtLegalHistory" name="txtLegalHistory" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Alcohol use:</span>
                    <textarea id="txtAlcoholUse" name="txtAlcoholUse" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Substance Use:</span>
                    <textarea id="txtSubstanceUse" name="txtSubstanceUse" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Tobacco:</span>
                    <textarea id="txtTobacco" name="txtTobacco" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                <span className='eleHeader' >Abuse:</span> 
                </p>

                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSuicidalThoughts" name="cbSuicidalThoughts" className='add-only' value="Neglect" />
                            Neglect
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSuicidalAttempts" name="cbSuicidalAttempts" className='add-only' value="Sexual" />
                            Sexual
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSuicidalIntent" name="cbSuicidalIntent" className='add-only' value="Physical" />
                            Physical
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSuicidalPlans" name="cbSuicidalPlans" className='add-only' value="Mental" />
                            Mental
                        </td>
                    </tr>
                </table>

                <h3>Mental Status Exam:</h3>
                <table>
                    <tr>
                        <td className='w-750'><span><strong>Appearance:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_1" name="cbAppearance_1" className='add-only' value="Neat/Well Groomed" />
                            Neat/Well Groomed
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_2" name="cbAppearance_2" className='add-only' value="Disheveled" />
                            Disheveled
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_3" name="cbAppearance_3" className='add-only' value="Bizarre" />
                            Bizarre
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_4" name="cbAppearance_4" className='add-only' value="Casual" />
                            Casual
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAppearance_5" name="cbAppearance_5" className='add-only' value="Age Appropriate" />
                            Age Appropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Orientation:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Person" />
                            Person</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Place" />
                            Place</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Time" />
                            Time</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Disoriented" />
                            Disoriented</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Intelligence:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntelligence_1" name="cbIntelligence_1" className='add-only' value="Intellectually Impaired" />
                            Intellectually Impaired
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntelligence_2" name="cbIntelligence_2" className='add-only' value="Borderline" />
                            Borderline
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntelligence_3" name="cbIntelligence_3" className='add-only' value="Average" />
                            Average
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbIntelligence_4" name="cbIntelligence_4" className='add-only' value="Above Average" />
                            Above Average
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Mood:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="Euthymic" />
                            Euthymic</td>
                        <td>
                            <input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="Euphoria" />
                            Euphoria, Elation</td>
                        <td>
                            <input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="Anger" />
                            Anger, Hostility</td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="Anxiety" />
                            Anxiety, Fear, Apprehension</td>
                        <td>
                            <input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="Blunted" />
                            Blunted, Dull, Bland</td>
                        <td>
                            <input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="Dysphoria" />
                            Dysphoria, Depression, Sadness</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Affect:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbAffect_1" name="cbAffect_1" className='add-only' value="Appropriate" />
                            Appropriate/Mood Congruent</td>
                        <td>
                            <input type="checkbox" id="cbAffect_2" name="cbAffect_2" className='add-only' value="Flat" />
                            Flat</td>
                        <td>
                            <input type="checkbox" id="cbAffect_3" name="cbAffect_3" className='add-only' value="Blunted" />
                            Blunted</td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbAffect_4" name="cbAffect_4" className='add-only' value="Constricted" />
                            Constricted</td>
                        <td>
                            <input type="checkbox" id="cbAffect_5" name="cbAffect_5" className='add-only' value="Labile" />
                            Labile</td>
                        <td>
                            <input type="checkbox" id="cbAffect_6" name="cbAffect_6" className='add-only' value="Inappropriate" />
                            Inappropriate</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Speech:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Appropriate" />
                            Appropriate</td>
                        <td>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Rapid" />
                            Rapid</td>
                        <td>
                            <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Slow" />
                            Slow</td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Loud" />
                            Loud</td>
                        <td>
                            <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Soft" />
                            Soft</td>
                        <td>
                            <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Mute" />
                            Mute</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Thought Process:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbThoughtProcess_1" name="cbThoughtProcess_1" className='add-only' value="Racing" />
                            Racing</td>
                        <td>
                            <input type="checkbox" id="cbThoughtProcess_2" name="cbThoughtProcess_2" className='add-only' value="Confusion" />
                            Confusion</td>
                        <td>
                            <input type="checkbox" id="cbThoughtProcess_3" name="cbThoughtProcess_3" className='add-only' value="Concrete" />
                            Concrete</td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbThoughtProcess_4" name="cbThoughtProcess_4" className='add-only' value="Abstract" />
                            Abstract</td>
                        <td className='w-500'>
                            <input type="checkbox" id="cbThoughtProcess_5" name="cbThoughtProcess_5" className='add-only' value="Difficulty Processing Information" />
                            Difficulty Processing Information</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Thought Content:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_1" name="cbThoughtContent_1" className='add-only' value="Consistent with Age" />
                            Consistent with Age
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_2" name="cbThoughtContent_2" className='add-only' value="Phobias" />
                            Phobias
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_3" name="cbThoughtContent_3" className='add-only' value="Compulsions" />
                            Compulsions
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_4" name="cbThoughtContent_4" className='add-only' value="Self-Pity" />
                            Self-Pity
                        </td>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_5" name="cbThoughtContent_5" className='add-only' value="Bizarre" />
                            Bizarre
                        </td>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_6" name="cbThoughtContent_6" className='add-only' value="Helplessness" />
                            Helplessness
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_7" name="cbThoughtContent_7" className='add-only' value="Resentful" />
                            Resentful
                        </td>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_8" name="cbThoughtContent_8" className='add-only' value="Sexual Preoccupation" />
                            Sexual Preoccupation
                        </td>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_9" name="cbThoughtContent_9" className='add-only' value="Worthlessness" />
                            Worthlessness
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_10" name="cbThoughtContent_10" className='add-only' value="Indecisiveness" />
                            Indecisiveness
                        </td>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_11" name="cbThoughtContent_11" className='add-only' value="Isolation" />
                            Isolation
                        </td>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_12" name="cbThoughtContent_12" className='add-only' value="Excessive Religiosity" />
                            Excessive Religiosity
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_13" name="cbThoughtContent_13" className='add-only' value="Fear of Harm" />
                            Fear of Harm
                        </td>
                        <td>
                            <input type="checkbox" id="cbThoughtContent_14" name="cbThoughtContent_14" className='add-only' value="Other" />
                            Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Insight:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbInsight_1" name="cbInsight_1" className='add-only' value="Acknowledges Problems" />
                            Acknowledges Problems</td>
                        <td>
                            <input type="checkbox" id="cbInsight_2" name="cbInsight_2" className='add-only' value="Minimizes Problems" />
                            Minimizes Problems</td>
                        <td>
                            <input type="checkbox" id="cbInsight_3" name="cbInsight_3" className='add-only' value="Denies Presence of Problems" />
                            Denies Presence of Problems</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbInsight_4" name="cbInsight_4" className='add-only' value="Blames Others" />
                            Blames Others Circumstances for Problems</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Judgment:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbJudgment_1" name="cbJudgment_1" className='add-only' value="Intact" />
                            Intact</td>
                        <td>
                            <input type="checkbox" id="cbJudgment_2" name="cbJudgment_2" className='add-only' value="Poor Impulse Control" />
                            Poor Impulse Control</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbJudgment_3" name="cbJudgment_3" className='add-only' value="Impaired" />
                            Impaired Ability to Make Routine Decisions</td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader' >Client Referred to PCP:</span>
                    <textarea id="txtClientReferred" name="txtClientReferred" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Impression:</span>
                    <textarea id="txtImpression" name="txtImpression" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Diagnosis:</span>
                    <textarea id="txtDiagnosis" name="txtDiagnosis" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Response:</span>
                    <textarea id="txtResponse" name="txtResponse" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Intervention:</span>
                    <textarea id="txtIntervention" name="txtIntervention" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Medications Prescribed:</span>
                    <textarea id="txtMedicationsPrescribed" name="txtMedicationsPrescribed" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Plan:</span>
                    <textarea id="txtPlan" name="txtPlan" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader' >Add On Codes:</span>
                    <textarea id="txtAOC" name="txtAOC" className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Staff Signature/Position/Credentials
                        </td>
                        <td className='small w-375'>Date
                        </td>
                    </tr>
                </table>










            </div>
        </form>

    )
}